import { LoopBackConfig } from './../../sdk/lb.config';
import { Http } from '@angular/http';
import { SelectWidget } from 'angular2-schema-form';
import { Component } from '@angular/core';
import { OnInit } from '@angular/core';

@Component({
  selector: 'app-sf-select-dynamic-widget',
  templateUrl: './select-dynamic.widget.html'
})
export class MySelectDynamicWidgetComponent extends SelectWidget implements OnInit {

  public options = [];
  private baseUrl = '';

  constructor(
    private http: Http
  ) {
    super();
    this.baseUrl = `${LoopBackConfig.getPath()}/${LoopBackConfig.getApiVersion()}`;
  }

  ngOnInit() {
    this.http.get(`${this.baseUrl}/${this.schema.model}`)
      .map((res: any) => res.json())
      .subscribe(data => {
        console.log(data);
        this.options = data;
      });
  }

}



// WEBPACK FOOTER //
// ./src/shared/form-widgets/select-dynamic/select-dynamic.widget.ts